<template>
    <div>
        <div class="col-md-12 text-center">
            <h3>What would you like to correct?</h3>
            <button
                    class="btn"
                    :class="correctVoice && !correctSubtitles ? 'btn-success' : ''"
                    @click="toggleChoice('voice')"
            >
                Voice
            </button>

            <button
                    class="btn"
                    :class="correctSubtitles && !correctVoice ? 'btn-success' : ''"
                    @click="toggleChoice('subtitles')"
            >
                Subtitles
            </button>

            <button
                    class="btn"
                    :class="correctSubtitles && correctVoice ? 'btn-success' : ''"
                    @click="toggleChoice('both')"
            >
                Both
            </button>
        </div>

        <form method="post" :action="saveRoute" enctype='multipart/form-data' ref="correctionForm">
            <input type="hidden" name="_token" :value="csrfToken" />
            <input
                    type="hidden"
                    name="corrections"
                    :value="(
                        correctSubtitles && correctVoice ? 'both'
                        : (correctSubtitles ? 'subtitles'
                            : (correctVoice ? 'voice'
                                : ''
                            )
                        )
                    )"
                    required />
            <div class="col-md-12">
                <voice-correction
                        v-if="correctVoice"
                        :lessonCode="lessonCode"
                        :voiceDownloadUrl="voiceDownloadUrl"
                ></voice-correction>

                <subtitle-correction
                        v-if="correctSubtitles"
                        :lessonCode="lessonCode"
                        :masterCuesJson="masterCuesJson"
                        :timestamps="timestamps"
                ></subtitle-correction>
            </div>

            <div class="col-md-12 text-right">
                <submit-button :disabled="!allDataIsValid"></submit-button>
            </div>
        </form>
    </div>
</template>

<script>
    let toastr = require('toastr')

    export default {
        props: {
            'lessonCode': String,
            'saveRoute': String,
            'masterCuesJson': String,
            'timestamps': String,
            'csrfToken': String,
            'voiceDownloadUrl': String,
        },

        data: function() {
            return {
                correctSubtitles: false,
                correctVoice: false,
                triggerUpdate: false,
            };
        },

        mounted() {
            this.addFormChangeListener();
        },

        computed: {
            allDataIsValid: function () {
                if (!this.triggerUpdate) {
                    return;
                }
                this.triggerUpdate = false;

                let form = this.$refs.correctionForm;
                if (form !== undefined) {
                    return form.checkValidity();
                }
                return false;
            },
        },

        methods: {
            toggleChoice: function (choice) {
                if (choice === 'subtitles') {
                    this.correctSubtitles = true;
                    this.correctVoice = false;
                } else if (choice === 'voice') {
                    this.correctVoice = true;
                    this.correctSubtitles = false;
                } else if (choice === 'both') {
                    this.correctSubtitles = true;
                    this.correctVoice = true;
                }

                this.formHasUpdated();
            },

            addFormChangeListener: function () {
                let form = this.$refs.correctionForm;
                let vm = this;
                form.addEventListener("input", function () {
                    vm.formHasUpdated();
                });
            },

            formHasUpdated: function () {
                let vm = this;
                setTimeout(function() {
                    vm.triggerUpdate = true;
                }, 50);
            }
        },
    };
</script>